var x = Object.defineProperty;
var e = (b, v) => {
  for (var m in v) x(b, m, {
    get: v[m],
    enumerable: !0
  });
};
var y = {};
e(y, {
  $scale: () => a,
  $semantic: () => i,
  $static: () => c
});
var a = {};
e(a, {
  color: () => t,
  dimension: () => o,
  letterSpacing: () => r
});
var t = {};
e(t, {
  blue100: () => j,
  blue200: () => q,
  blue300: () => E,
  blue400: () => I,
  blue50: () => N,
  blue500: () => J,
  blue600: () => K,
  blue700: () => Q,
  blue800: () => U,
  blue900: () => V,
  blue950: () => X,
  blueAlpha100: () => ct,
  blueAlpha200: () => nt,
  blueAlpha50: () => lt,
  carrot100: () => P,
  carrot200: () => M,
  carrot300: () => O,
  carrot400: () => G,
  carrot50: () => L,
  carrot500: () => $,
  carrot600: () => C,
  carrot700: () => D,
  carrot800: () => T,
  carrot900: () => Y,
  carrot950: () => F,
  carrotAlpha100: () => at,
  carrotAlpha200: () => st,
  carrotAlpha50: () => rt,
  gray00: () => u,
  gray100: () => z,
  gray200: () => w,
  gray300: () => S,
  gray400: () => W,
  gray50: () => f,
  gray500: () => H,
  gray600: () => B,
  gray700: () => R,
  gray800: () => k,
  gray900: () => A,
  grayAlpha100: () => et,
  grayAlpha200: () => tt,
  grayAlpha50: () => _e,
  grayAlpha500: () => ot,
  green100: () => ie,
  green200: () => de,
  green300: () => ge,
  green400: () => ye,
  green50: () => pe,
  green500: () => he,
  green600: () => ve,
  green700: () => me,
  green800: () => be,
  green900: () => xe,
  green950: () => ue,
  greenAlpha100: () => mt,
  greenAlpha200: () => bt,
  greenAlpha50: () => vt,
  pink100: () => Me,
  pink200: () => Oe,
  pink300: () => Ge,
  pink400: () => $e,
  pink50: () => Pe,
  pink500: () => Ce,
  pink600: () => De,
  pink700: () => Te,
  pink800: () => Ye,
  pink900: () => Fe,
  pink950: () => Ne,
  purple100: () => qe,
  purple200: () => Ee,
  purple300: () => Ie,
  purple400: () => Je,
  purple50: () => je,
  purple500: () => Ke,
  purple600: () => Qe,
  purple700: () => Ue,
  purple800: () => Ve,
  purple900: () => Xe,
  purple950: () => Ze,
  red100: () => _,
  red200: () => ee,
  red300: () => te,
  red400: () => oe,
  red50: () => Z,
  red500: () => re,
  red600: () => ae,
  red700: () => se,
  red800: () => le,
  red900: () => ce,
  red950: () => ne,
  redAlpha100: () => it,
  redAlpha200: () => dt,
  redAlpha50: () => pt,
  yellow100: () => ze,
  yellow200: () => we,
  yellow300: () => Se,
  yellow400: () => We,
  yellow50: () => fe,
  yellow500: () => He,
  yellow600: () => Be,
  yellow700: () => Re,
  yellow800: () => ke,
  yellow900: () => Ae,
  yellow950: () => Le,
  yellowAlpha100: () => yt,
  yellowAlpha200: () => ht,
  yellowAlpha50: () => gt
});
var u = "var(--seed-scale-color-gray-00)",
  f = "var(--seed-scale-color-gray-50)",
  z = "var(--seed-scale-color-gray-100)",
  w = "var(--seed-scale-color-gray-200)",
  S = "var(--seed-scale-color-gray-300)",
  W = "var(--seed-scale-color-gray-400)",
  H = "var(--seed-scale-color-gray-500)",
  B = "var(--seed-scale-color-gray-600)",
  R = "var(--seed-scale-color-gray-700)",
  k = "var(--seed-scale-color-gray-800)",
  A = "var(--seed-scale-color-gray-900)",
  L = "var(--seed-scale-color-carrot-50)",
  P = "var(--seed-scale-color-carrot-100)",
  M = "var(--seed-scale-color-carrot-200)",
  O = "var(--seed-scale-color-carrot-300)",
  G = "var(--seed-scale-color-carrot-400)",
  $ = "var(--seed-scale-color-carrot-500)",
  C = "var(--seed-scale-color-carrot-600)",
  D = "var(--seed-scale-color-carrot-700)",
  T = "var(--seed-scale-color-carrot-800)",
  Y = "var(--seed-scale-color-carrot-900)",
  F = "var(--seed-scale-color-carrot-950)",
  N = "var(--seed-scale-color-blue-50)",
  j = "var(--seed-scale-color-blue-100)",
  q = "var(--seed-scale-color-blue-200)",
  E = "var(--seed-scale-color-blue-300)",
  I = "var(--seed-scale-color-blue-400)",
  J = "var(--seed-scale-color-blue-500)",
  K = "var(--seed-scale-color-blue-600)",
  Q = "var(--seed-scale-color-blue-700)",
  U = "var(--seed-scale-color-blue-800)",
  V = "var(--seed-scale-color-blue-900)",
  X = "var(--seed-scale-color-blue-950)",
  Z = "var(--seed-scale-color-red-50)",
  _ = "var(--seed-scale-color-red-100)",
  ee = "var(--seed-scale-color-red-200)",
  te = "var(--seed-scale-color-red-300)",
  oe = "var(--seed-scale-color-red-400)",
  re = "var(--seed-scale-color-red-500)",
  ae = "var(--seed-scale-color-red-600)",
  se = "var(--seed-scale-color-red-700)",
  le = "var(--seed-scale-color-red-800)",
  ce = "var(--seed-scale-color-red-900)",
  ne = "var(--seed-scale-color-red-950)",
  pe = "var(--seed-scale-color-green-50)",
  ie = "var(--seed-scale-color-green-100)",
  de = "var(--seed-scale-color-green-200)",
  ge = "var(--seed-scale-color-green-300)",
  ye = "var(--seed-scale-color-green-400)",
  he = "var(--seed-scale-color-green-500)",
  ve = "var(--seed-scale-color-green-600)",
  me = "var(--seed-scale-color-green-700)",
  be = "var(--seed-scale-color-green-800)",
  xe = "var(--seed-scale-color-green-900)",
  ue = "var(--seed-scale-color-green-950)",
  fe = "var(--seed-scale-color-yellow-50)",
  ze = "var(--seed-scale-color-yellow-100)",
  we = "var(--seed-scale-color-yellow-200)",
  Se = "var(--seed-scale-color-yellow-300)",
  We = "var(--seed-scale-color-yellow-400)",
  He = "var(--seed-scale-color-yellow-500)",
  Be = "var(--seed-scale-color-yellow-600)",
  Re = "var(--seed-scale-color-yellow-700)",
  ke = "var(--seed-scale-color-yellow-800)",
  Ae = "var(--seed-scale-color-yellow-900)",
  Le = "var(--seed-scale-color-yellow-950)",
  Pe = "var(--seed-scale-color-pink-50)",
  Me = "var(--seed-scale-color-pink-100)",
  Oe = "var(--seed-scale-color-pink-200)",
  Ge = "var(--seed-scale-color-pink-300)",
  $e = "var(--seed-scale-color-pink-400)",
  Ce = "var(--seed-scale-color-pink-500)",
  De = "var(--seed-scale-color-pink-600)",
  Te = "var(--seed-scale-color-pink-700)",
  Ye = "var(--seed-scale-color-pink-800)",
  Fe = "var(--seed-scale-color-pink-900)",
  Ne = "var(--seed-scale-color-pink-950)",
  je = "var(--seed-scale-color-purple-50)",
  qe = "var(--seed-scale-color-purple-100)",
  Ee = "var(--seed-scale-color-purple-200)",
  Ie = "var(--seed-scale-color-purple-300)",
  Je = "var(--seed-scale-color-purple-400)",
  Ke = "var(--seed-scale-color-purple-500)",
  Qe = "var(--seed-scale-color-purple-600)",
  Ue = "var(--seed-scale-color-purple-700)",
  Ve = "var(--seed-scale-color-purple-800)",
  Xe = "var(--seed-scale-color-purple-900)",
  Ze = "var(--seed-scale-color-purple-950)",
  _e = "var(--seed-scale-color-gray-alpha-50)",
  et = "var(--seed-scale-color-gray-alpha-100)",
  tt = "var(--seed-scale-color-gray-alpha-200)",
  ot = "var(--seed-scale-color-gray-alpha-500)",
  rt = "var(--seed-scale-color-carrot-alpha-50)",
  at = "var(--seed-scale-color-carrot-alpha-100)",
  st = "var(--seed-scale-color-carrot-alpha-200)",
  lt = "var(--seed-scale-color-blue-alpha-50)",
  ct = "var(--seed-scale-color-blue-alpha-100)",
  nt = "var(--seed-scale-color-blue-alpha-200)",
  pt = "var(--seed-scale-color-red-alpha-50)",
  it = "var(--seed-scale-color-red-alpha-100)",
  dt = "var(--seed-scale-color-red-alpha-200)",
  gt = "var(--seed-scale-color-yellow-alpha-50)",
  yt = "var(--seed-scale-color-yellow-alpha-100)",
  ht = "var(--seed-scale-color-yellow-alpha-200)",
  vt = "var(--seed-scale-color-green-alpha-50)",
  mt = "var(--seed-scale-color-green-alpha-100)",
  bt = "var(--seed-scale-color-green-alpha-200)";
var o = {};
e(o, {
  fontSize10: () => xt,
  fontSize100: () => wt,
  fontSize1000: () => Mt,
  fontSize1100: () => Ot,
  fontSize1200: () => Gt,
  fontSize1300: () => $t,
  fontSize150: () => St,
  fontSize200: () => Wt,
  fontSize25: () => ut,
  fontSize300: () => Ht,
  fontSize400: () => Bt,
  fontSize50: () => ft,
  fontSize500: () => Rt,
  fontSize600: () => kt,
  fontSize700: () => At,
  fontSize75: () => zt,
  fontSize800: () => Lt,
  fontSize900: () => Pt
});
var xt = "var(--seed-scale-dimension-font-size-10)",
  ut = "var(--seed-scale-dimension-font-size-25)",
  ft = "var(--seed-scale-dimension-font-size-50)",
  zt = "var(--seed-scale-dimension-font-size-75)",
  wt = "var(--seed-scale-dimension-font-size-100)",
  St = "var(--seed-scale-dimension-font-size-150)",
  Wt = "var(--seed-scale-dimension-font-size-200)",
  Ht = "var(--seed-scale-dimension-font-size-300)",
  Bt = "var(--seed-scale-dimension-font-size-400)",
  Rt = "var(--seed-scale-dimension-font-size-500)",
  kt = "var(--seed-scale-dimension-font-size-600)",
  At = "var(--seed-scale-dimension-font-size-700)",
  Lt = "var(--seed-scale-dimension-font-size-800)",
  Pt = "var(--seed-scale-dimension-font-size-900)",
  Mt = "var(--seed-scale-dimension-font-size-1000)",
  Ot = "var(--seed-scale-dimension-font-size-1100)",
  Gt = "var(--seed-scale-dimension-font-size-1200)",
  $t = "var(--seed-scale-dimension-font-size-1300)";
var r = {};
e(r, {
  narrow200: () => Dt,
  narrow300: () => Tt,
  narrow400: () => Yt,
  none: () => Ct
});
var Ct = "var(--seed-scale-letter-spacing-none)",
  Dt = "var(--seed-scale-letter-spacing-narrow-200)",
  Tt = "var(--seed-scale-letter-spacing-narrow-300)",
  Yt = "var(--seed-scale-letter-spacing-narrow-400)";
var c = {};
e(c, {
  color: () => s,
  fontWeight: () => l
});
var s = {};
e(s, {
  staticBlack: () => Ft,
  staticBlackAlpha200: () => _t,
  staticBlackAlpha500: () => eo,
  staticBlue50: () => Xt,
  staticBlue800: () => Zt,
  staticCarrot50: () => qt,
  staticCarrot800: () => Et,
  staticGray900: () => jt,
  staticGreen50: () => It,
  staticGreen800: () => Jt,
  staticRed50: () => Ut,
  staticRed800: () => Vt,
  staticWhite: () => Nt,
  staticWhiteAlpha200: () => oo,
  staticWhiteAlpha50: () => to,
  staticYellow50: () => Kt,
  staticYellow800: () => Qt
});
var Ft = "var(--seed-static-color-static-black)",
  Nt = "var(--seed-static-color-static-white)",
  jt = "var(--seed-static-color-static-gray-900)",
  qt = "var(--seed-static-color-static-carrot-50)",
  Et = "var(--seed-static-color-static-carrot-800)",
  It = "var(--seed-static-color-static-green-50)",
  Jt = "var(--seed-static-color-static-green-800)",
  Kt = "var(--seed-static-color-static-yellow-50)",
  Qt = "var(--seed-static-color-static-yellow-800)",
  Ut = "var(--seed-static-color-static-red-50)",
  Vt = "var(--seed-static-color-static-red-800)",
  Xt = "var(--seed-static-color-static-blue-50)",
  Zt = "var(--seed-static-color-static-blue-800)",
  _t = "var(--seed-static-color-static-black-alpha-200)",
  eo = "var(--seed-static-color-static-black-alpha-500)",
  to = "var(--seed-static-color-static-white-alpha-50)",
  oo = "var(--seed-static-color-static-white-alpha-200)";
var l = {};
e(l, {
  bold: () => ao,
  regular: () => ro
});
var ro = "var(--seed-static-font-weight-regular)",
  ao = "var(--seed-static-font-weight-bold)";
var i = {};
e(i, {
  color: () => n,
  typography: () => p
});
var n = {};
e(n, {
  accent: () => Eo,
  danger: () => vo,
  dangerLow: () => mo,
  divider1: () => No,
  divider2: () => jo,
  divider3: () => qo,
  grayActive: () => Ko,
  grayHover: () => Po,
  grayPressed: () => Mo,
  inkText: () => Io,
  inkTextLow: () => Jo,
  onGrayOverlay100: () => Yo,
  onGrayOverlay50: () => To,
  onPrimary: () => so,
  onPrimaryLowOverlay100: () => Co,
  onPrimaryLowOverlay200: () => Do,
  onPrimaryLowOverlay50: () => $o,
  onPrimaryOverlay200: () => Go,
  onPrimaryOverlay50: () => Oo,
  overlayDim: () => xo,
  overlayLow: () => bo,
  paperAccent: () => Ho,
  paperBackground: () => Wo,
  paperContents: () => wo,
  paperDefault: () => So,
  paperDialog: () => fo,
  paperFloating: () => zo,
  paperSheet: () => uo,
  primary: () => lo,
  primaryHover: () => Bo,
  primaryLow: () => co,
  primaryLowActive: () => Ao,
  primaryLowHover: () => ko,
  primaryLowPressed: () => Lo,
  primaryPressed: () => Ro,
  secondary: () => no,
  secondaryLow: () => po,
  success: () => io,
  successLow: () => go,
  textSelection: () => Fo,
  warning: () => yo,
  warningLow: () => ho
});
var so = "var(--seed-semantic-color-on-primary)",
  lo = "var(--seed-semantic-color-primary)",
  co = "var(--seed-semantic-color-primary-low)",
  no = "var(--seed-semantic-color-secondary)",
  po = "var(--seed-semantic-color-secondary-low)",
  io = "var(--seed-semantic-color-success)",
  go = "var(--seed-semantic-color-success-low)",
  yo = "var(--seed-semantic-color-warning)",
  ho = "var(--seed-semantic-color-warning-low)",
  vo = "var(--seed-semantic-color-danger)",
  mo = "var(--seed-semantic-color-danger-low)",
  bo = "var(--seed-semantic-color-overlay-low)",
  xo = "var(--seed-semantic-color-overlay-dim)",
  uo = "var(--seed-semantic-color-paper-sheet)",
  fo = "var(--seed-semantic-color-paper-dialog)",
  zo = "var(--seed-semantic-color-paper-floating)",
  wo = "var(--seed-semantic-color-paper-contents)",
  So = "var(--seed-semantic-color-paper-default)",
  Wo = "var(--seed-semantic-color-paper-background)",
  Ho = "var(--seed-semantic-color-paper-accent)",
  Bo = "var(--seed-semantic-color-primary-hover)",
  Ro = "var(--seed-semantic-color-primary-pressed)",
  ko = "var(--seed-semantic-color-primary-low-hover)",
  Ao = "var(--seed-semantic-color-primary-low-active)",
  Lo = "var(--seed-semantic-color-primary-low-pressed)",
  Po = "var(--seed-semantic-color-gray-hover)",
  Mo = "var(--seed-semantic-color-gray-pressed)",
  Oo = "var(--seed-semantic-color-on-primary-overlay-50)",
  Go = "var(--seed-semantic-color-on-primary-overlay-200)",
  $o = "var(--seed-semantic-color-on-primary-low-overlay-50)",
  Co = "var(--seed-semantic-color-on-primary-low-overlay-100)",
  Do = "var(--seed-semantic-color-on-primary-low-overlay-200)",
  To = "var(--seed-semantic-color-on-gray-overlay-50)",
  Yo = "var(--seed-semantic-color-on-gray-overlay-100)",
  Fo = "var(--seed-semantic-color-text-selection)",
  No = "var(--seed-semantic-color-divider-1)",
  jo = "var(--seed-semantic-color-divider-2)",
  qo = "var(--seed-semantic-color-divider-3)",
  Eo = "var(--seed-semantic-color-accent)",
  Io = "var(--seed-semantic-color-ink-text)",
  Jo = "var(--seed-semantic-color-ink-text-low)",
  Ko = "var(--seed-semantic-color-gray-active)";
var p = {};
e(p, {
  bodyL1Bold: () => nr,
  bodyL1Regular: () => pr,
  bodyL2Bold: () => ir,
  bodyL2Regular: () => dr,
  bodyM1Bold: () => gr,
  bodyM1Regular: () => yr,
  bodyM2Bold: () => hr,
  bodyM2Regular: () => vr,
  caption1Bold: () => mr,
  caption1Regular: () => br,
  caption2Bold: () => xr,
  caption2Regular: () => ur,
  h1: () => Qo,
  h2: () => Uo,
  h3: () => Vo,
  h4: () => Xo,
  label1Bold: () => fr,
  label1Regular: () => zr,
  label2Bold: () => wr,
  label2Regular: () => Sr,
  label3Bold: () => Wr,
  label3Regular: () => Hr,
  label4Bold: () => Br,
  label4Regular: () => Rr,
  label5Bold: () => kr,
  label5Regular: () => Ar,
  label6Bold: () => Lr,
  label6Regular: () => Pr,
  subtitle1Bold: () => ar,
  subtitle1Regular: () => sr,
  subtitle2Bold: () => lr,
  subtitle2Regular: () => cr,
  title1Bold: () => Zo,
  title1Regular: () => _o,
  title2Bold: () => er,
  title2Regular: () => tr,
  title3Bold: () => or,
  title3Regular: () => rr
});
var Qo = {
    fontSize: "var(--seed-semantic-typography-h1-font-size)",
    fontWeight: "var(--seed-semantic-typography-h1-font-weight)",
    lineHeight: "var(--seed-semantic-typography-h1-line-height)",
    letterSpacing: "var(--seed-semantic-typography-h1-letter-spacing)"
  },
  Uo = {
    fontSize: "var(--seed-semantic-typography-h2-font-size)",
    fontWeight: "var(--seed-semantic-typography-h2-font-weight)",
    lineHeight: "var(--seed-semantic-typography-h2-line-height)",
    letterSpacing: "var(--seed-semantic-typography-h2-letter-spacing)"
  },
  Vo = {
    fontSize: "var(--seed-semantic-typography-h3-font-size)",
    fontWeight: "var(--seed-semantic-typography-h3-font-weight)",
    lineHeight: "var(--seed-semantic-typography-h3-line-height)",
    letterSpacing: "var(--seed-semantic-typography-h3-letter-spacing)"
  },
  Xo = {
    fontSize: "var(--seed-semantic-typography-h4-font-size)",
    fontWeight: "var(--seed-semantic-typography-h4-font-weight)",
    lineHeight: "var(--seed-semantic-typography-h4-line-height)",
    letterSpacing: "var(--seed-semantic-typography-h4-letter-spacing)"
  },
  Zo = {
    fontSize: "var(--seed-semantic-typography-title1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-title1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title1-bold-letter-spacing)"
  },
  _o = {
    fontSize: "var(--seed-semantic-typography-title1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-title1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title1-regular-letter-spacing)"
  },
  er = {
    fontSize: "var(--seed-semantic-typography-title2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-title2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title2-bold-letter-spacing)"
  },
  tr = {
    fontSize: "var(--seed-semantic-typography-title2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-title2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title2-regular-letter-spacing)"
  },
  or = {
    fontSize: "var(--seed-semantic-typography-title3-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-title3-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title3-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title3-bold-letter-spacing)"
  },
  rr = {
    fontSize: "var(--seed-semantic-typography-title3-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-title3-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-title3-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-title3-regular-letter-spacing)"
  },
  ar = {
    fontSize: "var(--seed-semantic-typography-subtitle1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-subtitle1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-subtitle1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-subtitle1-bold-letter-spacing)"
  },
  sr = {
    fontSize: "var(--seed-semantic-typography-subtitle1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-subtitle1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-subtitle1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-subtitle1-regular-letter-spacing)"
  },
  lr = {
    fontSize: "var(--seed-semantic-typography-subtitle2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-subtitle2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-subtitle2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-subtitle2-bold-letter-spacing)"
  },
  cr = {
    fontSize: "var(--seed-semantic-typography-subtitle2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-subtitle2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-subtitle2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-subtitle2-regular-letter-spacing)"
  },
  nr = {
    fontSize: "var(--seed-semantic-typography-body-l1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-l1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-l1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-l1-bold-letter-spacing)"
  },
  pr = {
    fontSize: "var(--seed-semantic-typography-body-l1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-l1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-l1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-l1-regular-letter-spacing)"
  },
  ir = {
    fontSize: "var(--seed-semantic-typography-body-l2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-l2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-l2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-l2-bold-letter-spacing)"
  },
  dr = {
    fontSize: "var(--seed-semantic-typography-body-l2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-l2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-l2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-l2-regular-letter-spacing)"
  },
  gr = {
    fontSize: "var(--seed-semantic-typography-body-m1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-m1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-m1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-m1-bold-letter-spacing)"
  },
  yr = {
    fontSize: "var(--seed-semantic-typography-body-m1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-m1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-m1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-m1-regular-letter-spacing)"
  },
  hr = {
    fontSize: "var(--seed-semantic-typography-body-m2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-m2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-m2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-m2-bold-letter-spacing)"
  },
  vr = {
    fontSize: "var(--seed-semantic-typography-body-m2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-body-m2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-body-m2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-body-m2-regular-letter-spacing)"
  },
  mr = {
    fontSize: "var(--seed-semantic-typography-caption1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-caption1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-caption1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-caption1-bold-letter-spacing)"
  },
  br = {
    fontSize: "var(--seed-semantic-typography-caption1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-caption1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-caption1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-caption1-regular-letter-spacing)"
  },
  xr = {
    fontSize: "var(--seed-semantic-typography-caption2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-caption2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-caption2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-caption2-bold-letter-spacing)"
  },
  ur = {
    fontSize: "var(--seed-semantic-typography-caption2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-caption2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-caption2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-caption2-regular-letter-spacing)"
  },
  fr = {
    fontSize: "var(--seed-semantic-typography-label1-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label1-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label1-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label1-bold-letter-spacing)"
  },
  zr = {
    fontSize: "var(--seed-semantic-typography-label1-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label1-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label1-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label1-regular-letter-spacing)"
  },
  wr = {
    fontSize: "var(--seed-semantic-typography-label2-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label2-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label2-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label2-bold-letter-spacing)"
  },
  Sr = {
    fontSize: "var(--seed-semantic-typography-label2-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label2-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label2-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label2-regular-letter-spacing)"
  },
  Wr = {
    fontSize: "var(--seed-semantic-typography-label3-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label3-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label3-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label3-bold-letter-spacing)"
  },
  Hr = {
    fontSize: "var(--seed-semantic-typography-label3-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label3-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label3-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label3-regular-letter-spacing)"
  },
  Br = {
    fontSize: "var(--seed-semantic-typography-label4-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label4-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label4-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label4-bold-letter-spacing)"
  },
  Rr = {
    fontSize: "var(--seed-semantic-typography-label4-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label4-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label4-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label4-regular-letter-spacing)"
  },
  kr = {
    fontSize: "var(--seed-semantic-typography-label5-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label5-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label5-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label5-bold-letter-spacing)"
  },
  Ar = {
    fontSize: "var(--seed-semantic-typography-label5-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label5-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label5-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label5-regular-letter-spacing)"
  },
  Lr = {
    fontSize: "var(--seed-semantic-typography-label6-bold-font-size)",
    fontWeight: "var(--seed-semantic-typography-label6-bold-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label6-bold-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label6-bold-letter-spacing)"
  },
  Pr = {
    fontSize: "var(--seed-semantic-typography-label6-regular-font-size)",
    fontWeight: "var(--seed-semantic-typography-label6-regular-font-weight)",
    lineHeight: "var(--seed-semantic-typography-label6-regular-line-height)",
    letterSpacing: "var(--seed-semantic-typography-label6-regular-letter-spacing)"
  };
var h = {};
e(h, {
  $semantic: () => g
});
var g = {};
e(g, {
  typography: () => d
});
var d = {};
e(d, {
  bodyL1Bold: () => Jr,
  bodyL1Regular: () => Kr,
  bodyL2Bold: () => Qr,
  bodyL2Regular: () => Ur,
  bodyM1Bold: () => Vr,
  bodyM1Regular: () => Xr,
  bodyM2Bold: () => Zr,
  bodyM2Regular: () => _r,
  caption1Bold: () => ea,
  caption1Regular: () => ta,
  caption2Bold: () => oa,
  caption2Regular: () => ra,
  h1: () => Mr,
  h2: () => Or,
  h3: () => Gr,
  h4: () => $r,
  label1Bold: () => aa,
  label1Regular: () => sa,
  label2Bold: () => la,
  label2Regular: () => ca,
  label3Bold: () => na,
  label3Regular: () => pa,
  label4Bold: () => ia,
  label4Regular: () => da,
  label5Bold: () => ga,
  label5Regular: () => ya,
  label6Bold: () => ha,
  label6Regular: () => va,
  subtitle1Bold: () => jr,
  subtitle1Regular: () => qr,
  subtitle2Bold: () => Er,
  subtitle2Regular: () => Ir,
  title1Bold: () => Cr,
  title1Regular: () => Dr,
  title2Bold: () => Tr,
  title2Regular: () => Yr,
  title3Bold: () => Fr,
  title3Regular: () => Nr
});
var Mr = "seed-semantic-typography-h1",
  Or = "seed-semantic-typography-h2",
  Gr = "seed-semantic-typography-h3",
  $r = "seed-semantic-typography-h4",
  Cr = "seed-semantic-typography-title1-bold",
  Dr = "seed-semantic-typography-title1-regular",
  Tr = "seed-semantic-typography-title2-bold",
  Yr = "seed-semantic-typography-title2-regular",
  Fr = "seed-semantic-typography-title3-bold",
  Nr = "seed-semantic-typography-title3-regular",
  jr = "seed-semantic-typography-subtitle1-bold",
  qr = "seed-semantic-typography-subtitle1-regular",
  Er = "seed-semantic-typography-subtitle2-bold",
  Ir = "seed-semantic-typography-subtitle2-regular",
  Jr = "seed-semantic-typography-body-l1-bold",
  Kr = "seed-semantic-typography-body-l1-regular",
  Qr = "seed-semantic-typography-body-l2-bold",
  Ur = "seed-semantic-typography-body-l2-regular",
  Vr = "seed-semantic-typography-body-m1-bold",
  Xr = "seed-semantic-typography-body-m1-regular",
  Zr = "seed-semantic-typography-body-m2-bold",
  _r = "seed-semantic-typography-body-m2-regular",
  ea = "seed-semantic-typography-caption1-bold",
  ta = "seed-semantic-typography-caption1-regular",
  oa = "seed-semantic-typography-caption2-bold",
  ra = "seed-semantic-typography-caption2-regular",
  aa = "seed-semantic-typography-label1-bold",
  sa = "seed-semantic-typography-label1-regular",
  la = "seed-semantic-typography-label2-bold",
  ca = "seed-semantic-typography-label2-regular",
  na = "seed-semantic-typography-label3-bold",
  pa = "seed-semantic-typography-label3-regular",
  ia = "seed-semantic-typography-label4-bold",
  da = "seed-semantic-typography-label4-regular",
  ga = "seed-semantic-typography-label5-bold",
  ya = "seed-semantic-typography-label5-regular",
  ha = "seed-semantic-typography-label6-bold",
  va = "seed-semantic-typography-label6-regular";
export { h as classNames, y as vars };